jQuery(document).ready(function ($) {
    if ($('#hero-slider').length) {
        new Swiper('#hero-slider', {
            slidesPerView: 3,
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
          	speed: 1500,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            scrollbar: {
                el: '.swiper-scrollbar'
                // hide: true,
            },
            breakpoints: {
                360: {
                    slidesPerView: 1
                },
                767: {
                    spaceBetween: 30
                }
            }
        });
    }
    if ($('.hero-banners__slider').length) {
        new Swiper('.hero-banners__slider', {
            slidesPerView: 1,
            loop: true,
            speed: 1500,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            keyboard: {
                enabled: true
            },
            navigation: {
                nextEl: '.hero-banners__slider .swiper-button-next',
                prevEl: '.hero-banners__slider .swiper-button-prev',
            },
        });
    }
    if ($('.specialty-art').length) {
        new Swiper('.specialty-art .swiper-container', {
            autoHeight: true,
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    }
    if ($('.collabs-slider').length) {
        new Swiper('.collabs-slider .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: '.collabs-buttons .swiper-button-next',
                prevEl: '.collabs-buttons .swiper-button-prev'
            },
            breakpoints: {
                360: {
                    spaceBetween: 10,
                    slidesPerView: 1
                },
                767: {
                    spaceBetween: 30,
                    slidesPerView: 2
                },
                1200: {
                    spaceBetween: 30,
                    slidesPerView: 3
                }
            }
        });
    }

    $(document).on('scroll', function (e) {
        let scrollTop = $(this).scrollTop();
        $('.parallax .asset', this).each(function () {
            let x = scrollTop * $(this).data('ratex');
            let y = scrollTop * $(this).data('ratey');
            if (y > 80) {
                y = 80
            } else if (y < -80) {
                y = -80
            }
            if (x > 80) {
                x = 80
            } else if (x < -80) {
                x = -80
            }
            // const x = (e.pageX * $(this).data('ratex')),
            //     y = (e.pageY * $(this).data('ratey'));
            $('img', this).css({
                transform: `translate3d(${x}px, ${y}px, 0px)`
            });
        });
    });

    $('img').prop('draggable', false);

    if ($('.sliders .slider').length) {
        $('.sliders .slider').each(function () {
            new Swiper(this, {
                slidesPerView: 'auto',
                spaceBetween: 30,
                freeMode: true,
                /*mousewheel: true,*/
                breakpoints: {
                    360: {
                        spaceBetween: 10
                    },
                    767: {
                        spaceBetween: 30
                    }
                }
            });
        });
    }

    $('.filter-tabs li a').on('click', function (e) {
        //e.preventDefault();
        if ($(this).attr('href') != '#') return true;
        if ($(this).parent().hasClass('visible')) {
            return false;
        }

        let parent = $(this).parents('.filter-parts');
        let idx = $(this).data('tab');

        $(this).parents('.filter-tabs').find('li').removeClass('visible');
        $(this).parent().addClass('visible');
        parent.find('.sliders .slider-holder').removeClass('visible');
        parent.find(`.sliders .slider-holder[data-tab="${idx}"]`).addClass('visible');

        let thisSlider = parent.find(`.sliders .slider-holder[data-tab="${idx}"] .slider`);
        thisSlider[0].swiper.update();

        // $('.filter-tabs-selector').each((i, el) => {
        //     // fix trouble with right options list
        //     let sectionId = $(el).parents('.shopify-section').attr('id');
        //     $('#' + sectionId + ' .filter-tabs-selector').select2({
        //         minimumResultsForSearch: -1,
        //         dropdownParent: $('#' + sectionId + ' .select-2-filters-container')
        //     });
        // });

        // trigger mobile select change
        let sectionId = $(this).parents('.shopify-section').attr('id');
        $('#' + sectionId + ' .filter-tabs-selector').val($(this).parent().index() + 1);
        $('#' + sectionId + ' .filter-tabs-selector').trigger('change');
        // $('#mySelect2').val('1'); // Select the option with a value of '1'
        // $('#mySelect2').trigger('change');
    });

    if ($('.press-slider-section .slider').length) {
        new Swiper('.press-slider-section .slider', {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            autoplay: {
                delay: 8000,
                disableOnInteraction: false
            }
        });
    }

    $('#mobile-menu-toggle').on('click', function () {
      	var body = $(document.body);
        if(body.hasClass('none-vis')){
            body.removeClass('none-vis');
            body.removeClass('ipad-scroll-block');
            $('html').removeClass('ipad-scroll-block');
        }else{
            body.addClass('none-vis');
            body.addClass('ipad-scroll-block');
            $('html').addClass('ipad-scroll-block');
        }
        $('#header #menu').stop(1, 1).slideToggle();
        $(this).toggleClass('opened');
    });

    /*if ($('#menu').is(':visible')) {
        $('#PageContainer').addClass("fixed-position");
    } else {
        $('body').removeClass("fixed-position");
    }*/

    if (screen.width < 768) {
        if ($('#mobile-menu-toggle').hasClass('opened')) {
            $('#PageContainer').addClass("fixed-position");
        } else {
            $('body').removeClass("fixed-position");
        }
    }

    /* disablde links */

    // $("ul.logos a").click(function (e){
    //     e.preventDefault()
    // });

    // $('.filter-tabs-selector').on('change', function () {
    //     var val = parseInt($(this).val());
    //     var item = $(this).siblings('.filter-tabs').find('li');
    //     item.eq(val-1).find('a').trigger('click');
    // });

    $('.filter-tabs-selector').each((i, el) => {
        // fix trouble with right options list
        let sectionId = $(el).parents('.shopify-section').attr('id');
        $('#' + sectionId + ' .filter-tabs-selector').select2({
            minimumResultsForSearch: -1,
            dropdownParent: $('#' + sectionId + ' .select-2-filters-container')
        });
    });

    // $('.filter-tabs-selector').select2({
    //     minimumResultsForSearch: -1,
    //     dropdownParent: $('.select-2-filters-container')
    // });

    $('.filter-tabs-selector').on('select2:select', function (e) {
        var val = $(e.currentTarget).find(':selected').index();
        var item = $(e.currentTarget).parents('.right').find('.filter-tabs').find('li');
        item.eq(val).find('a').trigger('click');
    });

  	
  	$(".filter-result-container input[type='radio']").change(function (e){
        e.preventDefault()

        var current_url = window.location.href,
            check_params = current_url.indexOf("+"),
            sParam,
            sURLVariables = current_url.split('+'),
            i;

        if(check_params == -1) {
            window.location.href = current_url+'/+'+$(this).attr('name')+':'+$(this).val()+"#filter"
        } else {

            var exists = false;
            for (i = 1; i < sURLVariables.length; i++) {
                sParam = sURLVariables[i].split(':');

                if($(this).attr('name') == sParam[0]) {
                    exists = true
                    if(~$(this).val().indexOf("all_")) {
                        var noFilter = window.location.href.replace('+'+sParam[0]+':'+sParam[1], '')
                        window.location.href = noFilter
                    } else {
                        var noHashURL = window.location.href.replace(/#.*$/, '');
                        var changeFilter = window.location.href.replace('+'+sParam[0]+':'+sParam[1], '+'+sParam[0]+':'+$(this).val())
                        window.location.href = changeFilter + "#filter"
                    }
                } else {
                    exists = false
                }
            } // end for
            if(!exists && !~$(this).val().indexOf("all_")) {
                var noHashURL = window.location.href.replace(/#.*$/, '');
                window.location.href = noHashURL+'+'+$(this).attr('name')+':'+$(this).val()+"#filter"
            }
        }
    })

    $("#filter .txt").click(function (e){
        if($(this).hasClass('opened')) {
            $("#filter .filter-result-container").slideUp()
            $(this).removeClass('opened')
        } else {
            $("#filter .filter-result-container").slideDown()
            $(this).addClass('opened')
        }
    })

    $(".parrent p").click(function(){
        if($(this).hasClass('opened')) {
            $(this).removeClass('opened')
            $(this).addClass('closed')
            $(this).parent().find('.child-cont').slideUp()
        } else {
            $(this).removeClass('closed')
            $(this).addClass('opened')
            $(this).parent().find('.child-cont').slideDown()
        }
    })

    $("button.apply").click(function () {
        $("#filter .filter-result-container").slideUp()
        $("#filter .txt").removeClass('opened')
    })

    var current_url = window.location.href,
        sParam,
        sURLVariables = current_url.split('+'),
        i;

    for (i = 1; i < sURLVariables.length; i++) {
        sParam = sURLVariables[i].split(':');
        if(sParam) {
            $("#filter .filter-result-container").show()
            $("#filter .txt").addClass('opened')
        }
        var param_url = sParam[1].replace('#filter','');
        $("#filter .filter-result-container").find("#"+param_url).attr('checked', true);
    }


});